import { render, staticRenderFns } from "./UsageFeesTokuyoFoodCostsTable.vue?vue&type=template&id=967099c0&scoped=true&lang=pug"
import script from "./UsageFeesTokuyoFoodCostsTable.vue?vue&type=script&lang=ts"
export * from "./UsageFeesTokuyoFoodCostsTable.vue?vue&type=script&lang=ts"
import style0 from "./UsageFeesTokuyoFoodCostsTable.vue?vue&type=style&index=0&id=967099c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967099c0",
  null
  
)

export default component.exports